import * as z from 'zod';

const LINK_SPLIT_REGEX = /\s*[,\n]\s*|\s+/;
const URL_REGEX =
  /^(https?:\/\/)?([\da-zA-Z\.-]+)\.([a-zA-Z\.]{2,6})([\/\w \.\-]*)*(\?[^\s,]*)?(\#[^\s,]*)?\/?$/i;

const normalizeUrlSchema = z.string().transform(url =>
  url
    .trim()
    .toLowerCase()
    .replace(/^(https?:\/\/)?/, '')
);

const urlSchema = z.string().regex(URL_REGEX);

export const normalizeUrl = (url: string): string => {
  return normalizeUrlSchema.parse(url);
};

export const parseLinks = (links: string): string[] => {
  return links
    .split(LINK_SPLIT_REGEX)
    .map(link => normalizeUrl(link))
    .filter(link => link.length > 0 && urlSchema.safeParse(link).success);
};
